import React, { forwardRef } from 'react';
import './styles.css';

export const Input = forwardRef(({
  type = 'text',
  placeholder,
  value,
  onChange,
  error,
  disabled = false,
  fullWidth = false,
  className = '',
  ...props
}, ref) => {
  const classes = [
    'input',
    error ? 'input-error' : '',
    disabled ? 'input-disabled' : '',
    fullWidth ? 'input-full' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className="input-wrapper">
      <input
        ref={ref}
        type={type}
        className={classes}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        {...props}
      />
      {error && <span className="input-error-message">{error}</span>}
    </div>
  );
});

Input.displayName = 'Input'; 